<ng-template entiteHost></ng-template>
